import type { LargeListFilterValue } from '@hotjar/global-filters';
import { LargeListFilterOperation } from '@hotjar/global-filters';
import type { CountryCode } from '@hotjar/country-lib';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';
import type { CountryCodeFilterDto } from '../filters/FiltersMappings';

export function countryFilterConverter(
  filterValue: LargeListFilterValue<CountryCode> | undefined,
): CountryCodeFilterDto | undefined {
  if (!filterValue) {
    return undefined;
  }
  return {
    type: IncomingFeedbackDtoFilters.COUNTRY,
    values: filterValue.selectedValues,
    operation:
      filterValue.operation === LargeListFilterOperation.IS_ANY_OF_THESE ? 'EQUALS' : 'NOT_EQUALS',
  };
}
